<template>
  <div
    class="item"
    @dblclick="openFolder"
    @click="selectFolder"
    :class="{ active: active.name == item.name }"
  >
    <BaseIcon
      v-if="!file"
      class="folder mrg-l-9"
      width="17"
      height="15"
      nameIcon="icon-folder-normal-list"
      pathIcon="icons-folder"
    />
    <BaseIcon
      v-else
      class="folder mrg-l-9"
      width="16.095"
      height="17.245"
      nameIcon="icon-folder-list-list"
      pathIcon="icons-folder"
    />
    <span>{{ item.name || item.dir }}</span>
  </div>
</template>

<script>
export default {
  props: ["item", "active", "file"],
  methods: {
    openFolder() {
      this.$emit("open", this.item);
    },
    selectFolder() {
      this.$emit("select", this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  align-items: center;
  height: 30px;
  padding: 0 20px;
  cursor: pointer;
  &:hover {
    background-color: #f4f4f4;
  }
  &.active {
    background-color: #dedede;
  }
}
</style>
